import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b293a5ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar container" }
const _hoisted_3 = { class: "navbar-list" }
const _hoisted_4 = { class: "icon-menu" }

import {onMounted, onUnmounted, ref} from "vue";
import CLogo from "@/components/header/CLogo.vue";
import CBurgerButton from "@/components/header/CBurgerButton.vue";
import CLanguageButton from "@/components/header/CLanguageButton.vue";
import CThemeButton from "@/components/header/CThemeButton.vue";
import AppFactory, {Menu} from "@/factories/AppFactory";


export default /*#__PURE__*/_defineComponent({
  __name: 'CHeader',
  setup(__props) {

const dataHeader = ref<HTMLElement|null>(null)
const dataNavToggleBtn = ref<HTMLElement|null>(null)

const toggleMenu = () => {
  dataHeader.value?.classList.toggle("nav-active");
  dataNavToggleBtn.value?.classList.toggle("active");
}

const closeMenu = () => {
  dataHeader.value?.classList.remove("nav-active");
  dataNavToggleBtn.value?.classList.remove("active");
}

const scroll = () => {
  if (window.scrollY >= 20) {
    dataHeader.value?.classList.add("active");
    // backTopBtn.classList.add("active");
  } else {
    dataHeader.value?.classList.remove("active");
    // backTopBtn.classList.remove("active");
  }
}

onMounted(() => {
  dataNavToggleBtn.value?.addEventListener("click", toggleMenu)
  window.addEventListener("scroll", scroll);
})

onUnmounted(() => {
  dataNavToggleBtn.value?.removeEventListener("click", toggleMenu)
  window.removeEventListener("scroll", scroll);
})

const menu: Array<Menu> = AppFactory.menu()



return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: "header",
    "data-header": "",
    ref_key: "dataHeader",
    ref: dataHeader
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CLogo),
      _createElementVNode("button", {
        class: "nav-toggle-btn",
        "aria-label": "Toggle Menu",
        "data-nav-toggle-btn": "",
        ref_key: "dataNavToggleBtn",
        ref: dataNavToggleBtn
      }, [
        _createVNode(_component_ion_icon, {
          name: "menu-outline",
          class: "menu-icon"
        }),
        _createVNode(_component_ion_icon, {
          name: "close-outline",
          class: "close-icon"
        })
      ], 512),
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: closeMenu
            }, [
              _createVNode(_component_router_link, {
                to: `/#${item.tag}`,
                class: "navbar-link",
                "data-nav-link": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(item.title)), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(CLanguageButton)
          ])
        ])
      ])
    ])
  ], 512))
}
}

})